import {
  IntrigueCard,
  TurnPhase,
  intrigueCardsDefRepository,
} from "~/business";
import { Colors, FontSize, Sizes, Spacing } from "~/jsx/theme";
import { useT } from "~/translation";
import { XAgentEffect } from "./XAgentEffect";
import { XOverlay } from "./XOverlay";
import { XTypography } from "./XTypography";
import { XResource } from "./XResource";
import { CSSProperties } from "react";

export const XIntrigueCard = ({
  width,
  card,
  onClick,
}: {
  width: number;
  card: IntrigueCard;
  onClick?: () => void;
}) => {
  const def = intrigueCardsDefRepository.getDef(card);
  const { name, phaseEffects } = def;
  const isSelectable = Boolean(onClick);
  const firstPhaseEffect = phaseEffects.at(0);
  if (!firstPhaseEffect) {
    throw new Error("unexpected: no phase effect");
  }

  return (
    <div
      style={{
        width,
        height: Sizes.intrigueCard.ratio * width,
        border: "solid 3px black",
        borderRadius: "3px",
        background: `linear-gradient(${Colors.yellow.dark} 0%,${Colors.yellow.dark} 50%,${Colors.yellow.darker} 100%)`,
        display: "flex",
        flexDirection: "column",
        boxShadow: isSelectable
          ? `${Colors.selection.selectable} 0px 0px 20px 7px`
          : "none",
        cursor: isSelectable ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      {name === "Corner the Market" ? (
        <div
          style={{
            color: Colors.common.white,
            display: "flex",
            flexDirection: "column",
            flex: 1,
          }}
        >
          <XPhaseDisplay phase={TurnPhase.EndGame} />
          <XEffectContainer
            style={{ flexDirection: "column", justifyContent: "space-around" }}
          >
            <XTypography style={{ fontSize: FontSize.px12, marginBottom: 6 }}>
              If you have at least 2 "The Spice Must Flow" cards: +
              <XResource type="victory" width={12} />.
            </XTypography>
            <XTypography style={{ fontSize: FontSize.px12 }}>
              If you have more "The Spice Must Flow" cards than each opponent: +
              <XResource type="victory" width={12} />.
            </XTypography>
          </XEffectContainer>
        </div>
      ) : name === "Plans Within Plans" ? (
        <div
          style={{
            color: Colors.common.white,
            display: "flex",
            flexDirection: "column",
            flex: 1,
          }}
        >
          <XPhaseDisplay phase={TurnPhase.EndGame} />
          <XEffectContainer
            style={{ flexDirection: "column", justifyContent: "space-around" }}
          >
            <XTypography style={{ fontSize: FontSize.px12 }}>
              Having 3 influence or more on 3 factions: +
              <XResource type="victory" width={12} />
            </XTypography>
            <XTypography style={{ textAlign: "center" }}>OR</XTypography>
            <XTypography style={{ fontSize: FontSize.px12 }}>
              {" "}
              Having 3 influence or more on all factions: +2 &nbsp;
              <XResource type="victory" width={12} />.
            </XTypography>
          </XEffectContainer>
        </div>
      ) : (
        phaseEffects.map(({ effects, phase }, index) => {
          return (
            <div
              key={index}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <XPhaseDisplay phase={phase} />
              {effects.map((effect, effectIndex) => (
                <XEffectContainer key={effectIndex}>
                  <XAgentEffect
                    effectDescription={effect}
                    width={37}
                    layout={phaseEffects.length > 1 ? "horizontal" : "vertical"}
                    context="intrigueCard"
                  />
                </XEffectContainer>
              ))}
            </div>
          );
        })
      )}
      {!isSelectable && <XOverlay />}
    </div>
  );
};

const XPhaseDisplay = ({ phase }: { phase: TurnPhase }) => {
  const { tPhase } = useT();
  return (
    <XTypography
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 32,
        backgroundColor: Colors.common.black,
      }}
      typographyStyle={{
        color: Colors.common.white,
        textAlign: "center",
      }}
    >
      {tPhase(phase)}
    </XTypography>
  );
};

const XEffectContainer = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: CSSProperties;
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        padding: Spacing.px8,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
